import { getObjectForDownload, getObjectUrl } from './mediaUtils'
import { s3ObjectToCloudfront, updateS3Key } from './storageUtils'

const mapper = [
  { poseKey: 'pose_center', value: 'center' },
  { poseKey: 'pose_left', value: 'left' },
  { poseKey: 'pose_right', value: 'right' },
  { poseKey: 'pose_upper', value: 'upper' },
  { poseKey: 'pose_lower', value: 'lower' },
  { poseKey: 'profile', value: 'profile' },
  { poseKey: 'front-smiling', value: 'front-smiling' },
  { poseKey: 'front-rest', value: 'front-rest' },
  { poseKey: 'composite', value: 'composite' }
]

export const parsePoseNameFromPath = path => mapper.find(({ poseKey }) => path.includes(poseKey))?.value

export const generateSelectedScanSummaryImageContents = async ({
  selectedPoses,
  sketchedPoses,
  parsedScanSummaryData
}) => {
  const contents = []
  for (let index = 0; index < selectedPoses.length; index++) {
    const position = selectedPoses[index]
    const editedImage = sketchedPoses[position]
    const initialImageContent = parsedScanSummaryData[position]
    const imageUrl = getObjectUrl(initialImageContent)
    const imageContent = updateS3Key(initialImageContent)
    const cache = editedImage || imageUrl || s3ObjectToCloudfront(initialImageContent)
    const content = editedImage
      ? Buffer.from(editedImage.replace(/^data:image\/\w+;base64,/, ''), 'base64')
      : imageUrl?.includes('private')
      ? await getObjectForDownload(imageUrl)
      : JSON.stringify(imageContent)

    contents.push({
      content,
      cache,
      isOriginalImage: !editedImage
    })
  }

  return contents
}
